<template>
  <section class="vacancies">
    <div class="l-content">
      <div class="vacancies__carousel">
        <MainCarousel :carousel="pageData.top_banner" />
      </div>

      <div class="container">
        <div class="container-inner vacancies__info">
          <div class="wpb_wrapper" v-html="pageData.description1" data-html></div>

          <div class="wpb_wrapper" v-html="pageData.description2" data-html></div>
        </div>

        <div v-if="pageData?.gallery?.images" class="container-inner vacancies__gallery">
          <GridGallery :photos="pageData.gallery.images" />
        </div>

        <div class="container-inner">
          <div class="vacancies__inputs">
            <BaseSelect
              key="vacancy_id"
              :label="$t('Ким Ви хочете працювати?')"
              :options="preparedVacanciesList"
              class="form-basket__input"
              :error="inputs.vacancy_id.error"
              :searchable="false"
              v-model="inputs.vacancy_id.value"
              @input="setInput(['vacancy_id', $event])"
            />

            <BaseInput
              :label="$t('Прізвище ім\'я по-батькові')"
              class="form-basket__input"
              :error="inputs.full_name.error"
              v-model="inputs.full_name.value"
              @input="setInput(['full_name', $event])"
            />

            <BaseInput
              type="tel"
              mask="+38 (099) 999-99-99"
              v-model="inputs.phone.value"
              placeholder="+38 (0__) ___-__-__"
              :label="$t('Телефон')"
              class="form-basket__input"
              :error="inputs.phone.error"
              @input="setInput(['phone', $event])"
            />

            <BaseInput
              type="email"
              v-model="inputs.email.value"
              :label="$t('Електронна пошта')"
              @input="setInput(['email', $event])"
              :error="inputs.email.error"
              class="form-basket__input"
            />

            <BaseInput
              key="entrance"
              v-model="inputs.age.value"
              type="number"
              :label="$t(`Вік`)"
              @input="setInput(['age', $event])"
              :error="inputs.age.error"
              class="form-basket__input"
            />

            <BaseInput
              :label="$t('Посилання на соціальні мережі')"
              v-model="inputs.social_links.value"
              @input="setInput(['social_links', $event])"
              :error="inputs.social_links.error"
              class="form-basket__input"
            />

            <BaseInput
              key="reason"
              v-model="inputs.reason.value"
              :label="$t('Чому хочете у нас працювати?')"
              textarea
              :error="inputs.reason.error"
              @input="setInput(['reason', $event])"
              row="4"
              class="form-basket__input _full-width"
            />
            <BaseInput
              key="photoFile"
              ref="photoInput"
              accept="image/png, image/jpg, image/jpeg, image/gif, image/svg+xml"
              :label="$t('Додайте фото (максимум 1 мегабайт)')"
              type="file"
              :error="inputs.photoFile.error"
              @input="setFileInput"
              class="form-basket__input _full-width"
            />
          </div>

          <BaseAlertInline :value="overallErrorsMix" class="basket__error _warning" />

          <div class="basket__form-btn">
            <button type="button" class="base-btn _black" @click="sendForm">
              {{ $t("Відправити") }}
              <BasePreloader v-if="false" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <LightBox :items="clearPhotosArray" :index="index" @close="onImgClick(null)" />
  </section>
</template>

<script>
import MainCarousel from "../components/MainCarousel";
import LightBox from "../components/LightBox";
import { POSITIONS } from "@/constants/vacancies";
import formMixins from "@/mixins/formMixins";
import GridGallery from "@/components/GridGallery.vue";
import { http } from "@/axios";
import { mapState } from "vuex";

export default {
  name: "Vacancies",
  mixins: [formMixins],
  components: {
    GridGallery,
    MainCarousel,
    LightBox,
  },
  data() {
    return {
      overallErrorsMix: null,
      index: null,
      POSITIONS,
      inputs: {
        full_name: { value: null, required: true },
        phone: { value: null, required: true },
        age: { value: null, required: true },
        vacancy_id: { value: null, required: true },
        social_links: { value: null },
        reason: { value: null, required: true },
        email: { value: null, required: true },
        photoFile: { value: null, required: true },
      },
    };
  },
  computed: {
    ...mapState("vacanciesList", ["vacanciesList"]),
    pageData() {
      return this.$store.state.page.pageData;
    },
    clearPhotosArray() {
      if (!this.pageData.gallery || !Array.isArray(this.pageData.gallery.images)) return [];
      return this.pageData.gallery.images.map((item) => item.image);
    },
    preparedVacanciesList() {
      if (!this.vacanciesList || !Array.isArray(this.vacanciesList.vacancies)) {
        return [];
      }
      return this.vacanciesList.vacancies.map((item) => item.vacancy_name);
    },
  },
  methods: {
    getVacanciesId(vacanciesName) {
      const vacancies = this.vacanciesList.vacancies.find(
        (item) => item.vacancy_name === vacanciesName
      );
      return vacancies ? vacancies.id : 0;
    },
    onImgClick(index) {
      this.index = index;
    },
    setInput([key, value]) {
      this.inputs[key].value = value;
    },
    setFileInput(event) {
      const file = event.target.files[0];
      this.inputs.photoFile.value = file || null;
    },
    resetForm() {
      for (let key in this.inputs) {
        this.inputs[key].value = null;
      }
      // reset file input manually
      if (this.$refs.photoInput && this.$refs.photoInput.$el) {
        const input = this.$refs.photoInput.$el.querySelector('input[type="file"]');
        if (input) input.value = '';
      }
    },
    sendForm() {
      this.resetErrorsMix();

      const formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        if (key === "phone" && value.value) {
          formData.append(key, `380${value.value}`);
        } else if (key === "vacancy_id") {
          formData.append(key, this.getVacanciesId(value.value));
        } else {
          formData.append(key, value.value);
        }
      }

      http
        .post("api/feedback/vacancy-apply", formData)
        .then((data) => {
          this.$vModal.open("message", {
            title:  this.$t("Заявку на вакансію успішно надіслано"),
            type: data.data.status,
          });
          this.resetForm();
        })
        .catch((e) => {
          this.handlerErrorMix(e, this.inputs);
        });
    },
  },
};
</script>

<style scoped>
/* your styles */
</style>
